import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-values-solution',
  templateUrl: './values-solution.component.html',
  styleUrls: ['./values-solution.component.scss']
})
export class ValuesSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
